import { cancelPendingTransactionsApi, fetchPendingTransactionsApi } from 'api/product-variant-api';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { getErrorString } from 'utils';

const usePendingTransaction = () => {
  const [pendingCheckout, setPendingCheckout] = useState(false);
  const [pendingCheckoutLoading, setPendingCheckoutLoading] = useState(true);
  const userId = useSelector((store) => store.patientUserData?.data?.id);
  const [cancelLoading, setCancelLoading] = useState(false);

  const cancelPendingTransaction = async (onSuccess = () => {}) => {
    setCancelLoading(true);
    try {
      const res = await cancelPendingTransactionsApi(userId);
      if (res && res?.status) {
        setPendingCheckout(false);
        onSuccess();
      }
    } catch (error) {
      toast.error(getErrorString(error));
    } finally {
      setCancelLoading(false);
    }
  };

  useEffect(() => {
    const fetchTransactions = async () => {
      setPendingCheckoutLoading(true);
      try {
        const res = await fetchPendingTransactionsApi(userId);
        if (res && res?.status) {
          setPendingCheckout({
            pending_transaction: res?.pending_transaction,
            reward_points: res?.reward_points,
          });
        }
      } catch (error) {
        console.error(getErrorString(error));
      } finally {
        setPendingCheckoutLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  return {
    pendingCheckout,
    cancelLoading,
    cancelPendingTransaction,
    setPendingCheckout,
    pendingCheckoutLoading,
  };
};

export default usePendingTransaction;
